<template>
  <div>
    <Card
      style="margin-top: 20px"
      :style="{
        backgroundImage: `url(${getWaterMarkStatus})`
      }"
    >
      <Table
        border
        stripe
        ref="table"
        :columns="columns"
        :loading="loading"
        :data="data"
        @on-row-click="rowClick"
      >
      </Table>
      <Row style="margin-top:15px">
        <Col span="19">
          <Page
            :total="total"
            :page-size="pageInfo.pageSize"
            @on-change="pageChange"
          />
        </Col>
      </Row>
    </Card>
    <Card
      style="margin-top: 20px"
      :style="{
        backgroundImage: `url(${getWaterMarkStatus})`
      }"
    >
      <p slot="title">奖惩管理</p>
      <Form
        style="margin: 30px 20px"
        :model="formItem"
        :label-width="150"
        inline
        label-position="left"
        v-if="showSelfData.PunishmentRecords"
      >
        <FormItem
          :label="lang == 'zh' ? chNameMap[val] : enNameMap[val]"
          v-for="(val, key) in sortfMap"
          :key="val"
          style="margin-right: 50px;"
          v-if="showSelfData[val] == '1'"
        >
          <DatePicker
            v-if="val == 'awarddate'"
            type="date"
            v-model="formItem[val]"
            style="min-width: 260px"
            :disabled="disableSelfData[val] == 0"
          ></DatePicker>
          <Checkbox
            v-else-if="val == 'paid'"
            v-model="formItem[val]"
            style="min-width: 250px;"
            :disabled="disableSelfData[val] == 0"
          ></Checkbox>
          <Select
            v-else-if="val == 'classcode'"
            :clearable="true"
            v-model="formItem[val]"
            style="min-width: 260px;"
            :disabled="disableSelfData[val] == 0"
          >
            <Option
              v-for="item in punishmentType"
              :value="item.code"
              :key="item.code"
              :label="item.name"
            ></Option>
          </Select>
          <Input
            v-else-if="val == 'note'"
            type="textarea"
            v-model="formItem[val]"
            style="min-width: 260px;"
            :disabled="disableSelfData[val] == 0"
          />
          <Input
            v-else
            v-model="formItem[val]"
            style="min-width: 260px;"
            :disabled="disableSelfData[val] == 0"
          />
        </FormItem>
      </Form>
    </Card>
    <div class="bottomBtn">
      <Button type="primary" @click="saveData()" :disabled="isEdit"
        >保存</Button
      >
      <Button @click="returnPage()" style="margin-left: 15px" v-if="plan"
        >返回</Button
      >
    </div>
  </div>
</template>

<script>
import axios from "axios";
import DateUtil from "../../../../../src/util/DateUtil";
import watermark from "@/util/watermark";

export default {
  data() {
    return {
      formItem: {},
      punishmentType: [],
      data: [],
      pageInfo: {
        itemCount: 0,
        pageNo: 1,
        pageSize: 10
      },
      loading: false,
      date: new DateUtil(),
      total: 1,
      isEdit: false,
      plan: "",
      id: "",
      showSelfData: {},
      chNameMap: {},
      enNameMap: {},
      userId: "",
      sortfMap: {},
      disableSelfData: {}
    };
  },
  created() {
    let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    this.userId = userInfo.serialnumber;
  },
  computed: {
    //国际化监听
    lang() {
      return this.$store.getters.selectLangeData;
    },
    getWaterMarkStatus() {
      return this.$store.getters.getWaterMarkStatus == 1
        ? watermark.addWaterMark()
        : "";
    },
    columns() {
      let column = [
        {
          title:
            this.lang == "zh"
              ? this.chNameMap.classcode
              : this.enNameMap.classcode,
          key: "classcode",
          align: "center",
          minWidth: 200
        },
        {
          title:
            this.lang == "zh" ? this.chNameMap.e_name : this.enNameMap.e_name,
          key: "eName",
          align: "center",
          minWidth: 200
        },
        {
          title:
            this.lang == "zh" ? this.chNameMap.c_name : this.enNameMap.c_name,
          key: "cName",
          align: "center",
          minWidth: 200
        },
        {
          title:
            this.lang == "zh"
              ? this.chNameMap.awarddate
              : this.enNameMap.awarddate,
          key: "awarddate",
          align: "center",
          render: (h, params) => {
            return h(
              "span",
              this.date.dateVal(params.row.awarddate, "YYYY/MM/DD")
            );
          },
          minWidth: 200
        },
        {
          title: this.lang == "zh" ? this.chNameMap.paid : this.enNameMap.paid,
          key: "paid",
          align: "center",
          render: (h, params) => {
            return h("span", params.row.paid == 0 ? "否" : "是");
          },
          minWidth: 200
        },
        {
          title:
            this.lang == "zh" ? this.chNameMap.amount : this.enNameMap.amount,
          key: "amount",
          align: "center",
          minWidth: 200
        }
      ];
      let arr = [];
      arr = column.filter(item => {
        return this.showSelfData[item.key] == 1;
      });
      return arr;
    }
  },
  methods: {
    saveData() {
      this.$Modal.confirm({
        title: this.$notice("sureSave"),
        content: "",
        onOk: () => {
          let obj = {
            paid: (this.paid = this.formItem.paid == true ? 1 : 0),
            serialnumber: this.plan,
            ...this.formItem
          };
          axios
            .post("/userPunishment/rollBackUserPunishmentInfo", obj)
            .then(res => {
              if (res) {
                this.getTableData();
              }
            });
        },
        onCancel: () => {}
      });
    },
    returnPage() {
      this.$router.back();
    },
    getData(id, plan) {
      (this.plan = plan ? plan : ""), (this.id = id);
      this.getTableData();
    },
    getTableData() {
      let obj = {
        pageNo: this.pageInfo.pageNo,
        pageSize: this.pageInfo.pageSize,
        serialnumber: this.plan ? this.plan : this.userId,
        sheetId: this.id,
        bePersonal: this.plan ? "0" : "1" // 0：员工档案 1：个人档案
      };
      this.loading = true;
      axios
        .post("/userPunishment/researchUserPunishmentInfo", obj)
        .then(res => {
          this.loading = false;
          if (res) {
            this.data = res.data;
            this.total = Number(res.pageInfo.total);
            this.punishmentType = res.optionData.CLASSCODE;
            this.chNameMap = res.chNameMap;
            this.enNameMap = res.enNameMap;
            this.showSelfData = res.showSelfData;
            if (res.disableSelfData.PunishmentRecords == "0") {
              this.isEdit = true;
            } else {
              this.isEdit = false;
            }
            this.disableSelfData = res.disableSelfData;
            this.sortfMap = res.sortfMap;
            delete this.sortfMap[15];
          }
        });
    },
    pageChange(val) {
      this.pageInfo.pageNo = val;
      this.getData();
    },
    rowClick(row, index) {
      this.formItem = row;
      this.formItem.classcode = row.classcode;
      this.formItem.paid = !!+this.formItem.paid;
      //this.isEdit = false
    }
  }
};
</script>

<style scoped>
.formRow {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.formCol {
  width: calc((100% - 210px) / 3);
  float: left;
  /* margin-right: 30px; */
}
@media screen and (max-width: 1300px) and (min-width: 800px) {
  .formCol {
    width: calc((100% - 40px) / 2);
  }
}
@media screen and (max-width: 800px) {
  .formCol {
    width: 100%;
  }
}
.bottomBtn {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}
.ivu-date-picker {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/process/MyQuery/components/PunishmentRecords.vue